import React from "react";

import { calculateAvailableSeats } from "../../helpers/calculations";
import { formatCurrency } from "../../helpers/formatters";
import { BusMapData } from "../../types/app.types";

interface StatisticsCardProps {
  busMapData: BusMapData;
}

export const StatisticsCard: React.FC<StatisticsCardProps> = ({
  busMapData,
}) => {
  const { statistics, maxDensityStats } = busMapData;
  const isFixedSeating = statistics.isFixedSeating;
  const maxAvailableSeats = calculateAvailableSeats(
    statistics.totalSeats,
    maxDensityStats?.maxOccupancyAtPoint || 0
  );

  return (
    <div className="info-card statistics-card">
      <h4 className="info-card-title">
        <span className="card-icon">📊</span>
        Статистика заповнення
      </h4>

      {statistics.totalRevenue > 0 && (
        <div className="total-revenue-item">
          <div className="revenue-label">💰 Загальна вартість:</div>
          <div className="revenue-value">
            {formatCurrency(statistics.totalRevenue)}
          </div>
        </div>
      )}

      <div className="statistics-grid">
        <div className="stat-item general">
          <div className="stat-value">{statistics.totalSeats}</div>
          <div className="stat-label">
            {isFixedSeating
              ? "Загальна кількість місць"
              : "Максимальна місткість"}
          </div>
        </div>

        <div className="stat-item occupied">
          <div className="stat-value">{statistics.occupiedSeats}</div>
          <div className="stat-label">
            {isFixedSeating ? "Кількість зайнятих місць" : "Продано квитків"}
          </div>
        </div>

        {isFixedSeating && (
          <div className="stat-item available">
            <div className="stat-value">{statistics.availableSeats}</div>
            <div className="stat-label">Доступні місця</div>
          </div>
        )}

        <div className="stat-item max_available">
          <div className="stat-value">{maxAvailableSeats}</div>
          <div className="stat-label">Максимальна кількість вільних місць</div>
        </div>
      </div>

      <div className="occupancy-bar">
        <div className="occupancy-label">Заповненість автобуса:</div>
        <div className="occupancy-progress">
          <div
            className="occupancy-fill"
            style={{ width: `${statistics.occupancyRate}%` }}
          ></div>
        </div>
        <div className="occupancy-percentage">{statistics.occupancyRate}%</div>
      </div>
    </div>
  );
};
